import axiosInstance from './api';

export const getAdminUserStats = () => axiosInstance.get('/user/dashboard-stats');

export const getOrderStats = () => axiosInstance.get('/commande/stats');

export const getReportStats = () => axiosInstance.get('/reports/stats');
export const getEmailStats = () => axiosInstance.get('/mail/stats');
